import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import { Grid, Button, Input, Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Add extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    selectedStatus: 'Active'
  };

  componentDidMount() {
    if (this.props.type == 'add') {

    }
    else {
      this.getState();
    }
  }

  componentDidUpdate(props) {
    if (props.id != this.props.id) {
      this.getState();
    }
  }

  getState() {
    this.setState({
      selectedStatus: this.props.status,
      mode: this.props.mode
    })
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  handlechanges = (type) => (f, { value }) => {
    this.setState({ [type]: value });
  }

  submit() {
    let context = this;
    let mode = this.state.mode;
    let code = this.state.code;
    let status = this.state.selectedStatus;
    context.setState({ load: true, message: 'Adding Mode' })
    $.ajax({
      type: 'POST',
      data: { 'mode': mode, 'status': status, 'code': code },
      url: Server() + 'addmenu/mode/add.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          alert('added');
          context.setState({ open: false })
          context.props.getMode();
        }
        else {
          alert('Try again!!');
        }
      },
      error: function(e)
      {
        alert('Try again!!');
        context.setState({
          load: false
        });
      }
    });
  }

  mode = (f, { value }) => {
    this.setState({ selectedStatus: value });
  }

  update() {
    let context = this;
    let id = this.props.id;
    let mode = this.state.mode;
    let code = this.state.code;
    let status = this.state.selectedStatus;
    context.setState({ load: true, message: 'Updating Mode' })
    $.ajax({
      type: 'POST',
      data: { 'mode': mode, 'status': status, 'id': id, 'code': code },
      url: Server() + 'addmenu/mode/update.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ open: false })
          context.props.getMode();
        }
      },
      error: function(e)
      {
        alert('Try again!!');
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    const { classes } = this.props;

    let modeOption = [
      { key: 'Active', text: 'Active', value: 'Active' },
      { key: 'Inactive', text: 'Inactive', value: 'Inactive' }
    ]
    return (
      <React.Fragment>
        { (this.props.type == 'edit') ?
          (
            <div>
              <div style={{cursor: 'pointer'}} onClick={this.handleClickOpen}>Edit</div>
            </div>
            
          ) :
          (
            <div>
              { this.props.menuPermission.add ?
                <Button primary onClick={this.handleClickOpen} style={{display: this.props.modeledit}}>Add Mode</Button>
                :''
              }
            </div>
          )
        }
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title" >
          <DialogTitle id="max-width-dialog-title">Mode</DialogTitle>
          <DialogContent style={{height: 150}}>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Enter Mode<br/>
                <Input onChange={this.handlechanges('mode')} value={this.state.mode} focus fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                CODE<br/>
                <Input onChange={this.handlechanges('code')} value={this.state.code} focus fluid />
                Max. 5 Char
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                Select Status<br/>
                <Dropdown fluid
                  id="Mode" onChange={this.mode}
                  search selection options={modeOption}
                  value={this.state.selectedStatus} fluid style={{ borderColor: '#5A9CBB' }} />
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
            { (this.props.type == 'add') ?
              (
                <div>
                  <Button onClick={this.submit.bind(this)} color="primary">Submit</Button>
                </div>
              ) :
              (
                <div>
                  <Button onClick={this.update.bind(this)} color="primary">Update</Button>
                </div>
              )
            }
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Add.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Add);
